import { useState } from "react"

import { post } from "./api.tsx"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

interface Props {
  asset: string
  claimOfferUrl: string
  exploreUrl: string
  handleCancellation: func
  surveyOption: string
  trackMutationError: func
}

const ExclusiveOffer = ({asset, claimOfferUrl, exploreUrl, handleCancellation, surveyOption, trackMutationError}: Props) => {
  const [loading, updateLoading] = useState(false)
  const errorMessage = "There was a problem claiming your offer. Please contact support for more information."

  const handleOffer = () => {
    updateLoading(true)
    post(claimOfferUrl).then(data => {
      if (data.ok) {
        logIFTTTNextAction("statechange", {
          object_type: "user",
          object_id: window.App.user.id,
          object_status: "claim_offer",
          location_type: "cancel_plan_confirmation_claim_offer",
          state: surveyOption,
        })

        window.appendFlash("You got 10% off for your next payment", "success", () => {
          window.Turbolinks?.visit(exploreUrl) || window.location.assign(exploreUrl)
        })
      } else {
        trackMutationError("userSubscriptionPromoCodeUpdate", data.error, errorMessage, updateLoading)
      }
    }).catch(error => {
      trackMutationError("userSubscriptionPromoCodeUpdate", error, errorMessage, updateLoading)
    })
  }

  return (
    <div>
      <h1 className="mt4 mb4 mb2--phone mb2--small-phone">Exclusive offer</h1>

      <p className="mt0 mb4">Get 10% off your next payment.</p>

      <img src={asset} width="288" height="256" />

      <div className="cancellation-actions mt4 mt8--phone mt8--small-phone">
        <button className="button-primary" onClick={handleOffer} disabled={loading}>Claim offer</button>
        <a className={`link-standalone mt4 ${loading && "disabled"}`} onClick={() => handleCancellation(updateLoading)}>No thanks, just cancel my subscription</a>
      </div>
    </div>
  )
}

export default ExclusiveOffer
